"use strict";
import { debounce } from '../utils.js';
import { guests } from '../middleware/guests.js';

const getGuestHtmlFormGroup = (guest) => {
  return ` 
    <div class="guest-form-group" id="guest-form-group-${guest.id}"> 
        <h3 id="guestName-${guest.id}" data-guest-id="${guest.id}" class="guest-name">${guest.name}</h3>
        
        <div class="mb-3">
            <label for="email-${guest.id}" class="form-label sr-only">Email</label>
            <input type="email" class="form-control" value="${guest.email ? guest.email : ""}" id="email-${guest.id}" placeholder="Email">
        </div>

        <div class="mb-3 d-flex justify-content-between align-items-center">
            <label for="confirmationOptions" class="form-label mb-0">Confirmez votre présence ?</label>
            <div class="btn-group" role="group" aria-toggle="buttons">
                <input type="radio" class="btn-check" name="confirmationOptions-${guest.id}" id="confirmationOptionsYes-${guest.id}" value="true" autocomplete="off" ${guest.is_confirmed ? "checked" : ""}>
                <label class="btn btn-outline-primary" for="confirmationOptionsYes-${guest.id}">Oui</label>

                <input type="radio" class="btn-check" name="confirmationOptions-${guest.id}" id="confirmationOptionsNo-${guest.id}" value="false" autocomplete="off" ${guest.is_confirmed ? "" : "checked"}>
                <label class="btn btn-outline-primary" for="confirmationOptionsNo-${guest.id}">Non</label>
            </div>
        </div>

        <div class="mb-3 d-flex justify-content-between align-items-center">
            <label for="vegeOptions" class="form-label mb-0">Voulez-vous un menu végétarien ?</label>
            <div class="btn-group" role="group" aria-toggle="buttons">
                <input type="radio" class="btn-check" name="vegeOptions-${guest.id}" id="vegeOptionsYes-${guest.id}" value="true" autocomplete="off" ${guest.is_vege ? "checked" : ""}>
                <label class="btn btn-outline-primary" for="vegeOptionsYes-${guest.id}">Oui</label>

                <input type="radio" class="btn-check" name="vegeOptions-${guest.id}" id="vegeOptionsNo-${guest.id}" value="false" autocomplete="off" ${guest.is_vege ? "" : "checked"}>
                <label class="btn btn-outline-primary" for="vegeOptionsNo-${guest.id}">Non</label>
            </div>
        </div>

        <div class="mb-3 d-flex justify-content-between align-items-center">
            <label for="alcoholfreeOptions" class="form-label mb-0">Voulez-vous être dans une table sans alcool ?</label>
            <div class="btn-group" role="group" aria-toggle="buttons">
                <input type="radio" class="btn-check" name="alcoholfreeOptions-${guest.id}" id="alcoholfreeOptionsYes-${guest.id}" value="true" autocomplete="off" ${guest.is_notalcool ? "checked" : ""}>
                <label class="btn btn-outline-primary" for="alcoholfreeOptionsYes-${guest.id}">Oui</label>

                <input type="radio" class="btn-check" name="alcoholfreeOptions-${guest.id}" id="alcoholfreeOptionsNo-${guest.id}" value="false" autocomplete="off" ${guest.is_notalcool ? "" : "checked"}>
                <label class="btn btn-outline-primary" for="alcoholfreeOptionsNo-${guest.id}">Non</label>
            </div>
        </div>

        <div class="mb-3">
            <label for="comments-${guest.id}" class="form-label">Commentaires et infos additionnelles</label>
            <textarea title="infos additionelles, commentaires, allergies ? ..." class="form-control" id="comments-${guest.id}" rows="3">${guest.comments ? guest.comments : ""}</textarea>
        </div>
    </div>
  `;
};

const getBabyGuestHtmlFormGroup = (guest) => {
  return `
    <div class="guest-form-group guest-baby-form-group" id="guest-form-group-${guest.id}">
        <h3 id="guestName-${guest.id}" data-guest-id="${guest.id}" class="guest-name">${guest.name}</h3>
        
        <div class="mb-3 d-flex justify-content-between align-items-center">
            <label for="confirmationOptions-${guest.id}" class="form-label mb-0">Confirmez votre présence ?</label>
            <div class="btn-group" role="group" aria-toggle="buttons">
                <input type="radio" class="btn-check" name="confirmationOptions-${guest.id}" id="confirmationOptionsYes-${guest.id}" value="true" autocomplete="off" ${guest.is_confirmed ? "checked" : ""}>
                <label class="btn btn-outline-primary" for="confirmationOptionsYes-${guest.id}">Oui</label>

                <input type="radio" class="btn-check" name="confirmationOptions-${guest.id}" id="confirmationOptionsNo-${guest.id}" value="false" autocomplete="off" ${guest.is_confirmed ? "" : "checked"}>
                <label class="btn btn-outline-primary" for="confirmationOptionsNo-${guest.id}">Non</label>
            </div>
        </div>

        <div class="mb-3">
            <label for="comments-${guest.id}" class="form-label">Commentaires et infos additionnelles</label>
            <textarea title="infos additionelles, commentaires, allergies ? ..." class="form-control" id="comments-${guest.id}" rows="3">${guest.comments ? guest.comments : ""}</textarea>
        </div>
    </div>
  `;
};

const getChildGuestHtmlFormGroup = (guest) => {
  return `
    <div class="guest-form-group child-baby-form-group" id="guest-form-group-${guest.id}">
        <h3 id="guestName-${guest.id}" data-guest-id="${guest.id}" class="guest-name">${guest.name}</h3>
        
        <div class="mb-3 d-flex justify-content-between align-items-center">
            <label for="confirmationOptions-${guest.id}" class="form-label mb-0">Confirmez votre présence ?</label>
            <div class="btn-group" role="group" aria-toggle="buttons">
                <input type="radio" class="btn-check" name="confirmationOptions-${guest.id}" id="confirmationOptionsYes-${guest.id}" value="true" autocomplete="off" ${guest.is_confirmed ? "checked" : ""}>
                <label class="btn btn-outline-primary" for="confirmationOptionsYes-${guest.id}">Oui</label>

                <input type="radio" class="btn-check" name="confirmationOptions-${guest.id}" id="confirmationOptionsNo-${guest.id}" value="false" autocomplete="off" ${guest.is_confirmed ? "" : "checked"}>
                <label class="btn btn-outline-primary" for="confirmationOptionsNo-${guest.id}">Non</label>
            </div>
        </div>

        <div class="mb-3 d-flex justify-content-between align-items-center">
            <label for="menuChildOptions" class="form-label mb-0">Voulez-vous un menu Enfant ?</label>
            <div class="btn-group" role="group" aria-toggle="buttons">
                <input type="radio" class="btn-check" name="menuChildOptions-${guest.id}" id="menuChildOptionsYes-${guest.id}" value="true" autocomplete="off" ${guest.is_menuChild ? "checked" : ""}>
                <label class="btn btn-outline-primary" for="menuChildOptionsYes-${guest.id}">Oui</label>

                <input type="radio" class="btn-check" name="menuChildOptions-${guest.id}" id="menuChildOptionsNo-${guest.id}" value="false" autocomplete="off" ${guest.is_menuChild ? "" : "checked"}>
                <label class="btn btn-outline-primary" for="menuChildOptionsNo-${guest.id}">Non</label>
            </div>
        </div>

        <div class="mb-3">
            <label for="comments-${guest.id}" class="form-label">Commentaires et infos additionnelles</label>
            <textarea title="infos additionelles, commentaires, allergies ? ..." class="form-control" id="comments-${guest.id}" rows="3">${guest.comments ? guest.comments : ""}</textarea>
        </div>
    </div>
  `;
};


const isValidGuestName = (name, guestNames) => {
  const inputValue = name.trim().toLowerCase();
  const lowerCaseGuestNames = guestNames.map((guest) => guest.toLowerCase());
  return lowerCaseGuestNames.includes(inputValue);
};

const validateFormSubmission = (event, $input, guestNames) => {
  const $errorMessage = $("#error-message");
  if ($input.val().trim() === "") {
    $errorMessage.hide(); // Ne pas afficher le message d'erreur si le champ est vide
    $("#submitAttendancyBtn").prop("disabled", true);
    return false;
  } else if (!isValidGuestName($input.val(), guestNames)) {
    event.preventDefault();
    $errorMessage.show();
    $("#submitAttendancyBtn").prop("disabled", true);
    return false;
  } else {
    $errorMessage.hide();
    $("#submitAttendancyBtn").prop("disabled", false);
    return true;
  }
};

const displayComesWith = async (guestName) => {
  const guestWithassociatedGuests = await guests.getComesWithGuests(guestName);
  let htmlContent = "";
  let isSubmitEnabled = false;

  if (guestWithassociatedGuests.length > 0) {
    const mainGuest = guestWithassociatedGuests[0];
    if (mainGuest.is_baby || mainGuest.is_child) {
      isSubmitEnabled = false;
      htmlContent = `<p style="margin-left:10px">Petit Enfant! Appelle tes parents et baraka men bsalat</p>`;
    } else {
      htmlContent += getGuestHtmlFormGroup(mainGuest);
      isSubmitEnabled = true;

      if (guestWithassociatedGuests.length > 1) {
        guestWithassociatedGuests.slice(1).forEach((guest) => {
          if (guest.is_child) {
            htmlContent += getChildGuestHtmlFormGroup(guest);
          } else if (guest.is_baby) {
            htmlContent += getBabyGuestHtmlFormGroup(guest);
          } else {
            htmlContent += getGuestHtmlFormGroup(guest);
          }
        });
      }
    }
  }
  $("#guestListContainer").html(htmlContent);
  $("#submitAttendancyBtn").prop("disabled", !isSubmitEnabled);
};

// Validation function
const validateNameFromList = ($input, guestNames) => {
  const $errorMessage = $("#error-message");
  const $formContent = $("#form-content");
  if ($input.val().trim() === "") {
    $errorMessage.hide();
    $formContent.hide();
    $("#submitAttendancyBtn").prop("disabled", true);
  } else if (!isValidGuestName($input.val(), guestNames)) {
    $errorMessage.show();
    $formContent.hide();
    $("#submitAttendancyBtn").prop("disabled", true);
  } else {
    $errorMessage.hide();
    $formContent.show();
    displayComesWith($input.val());
    $("#submitAttendancyBtn").prop("disabled", false);
  }
};

const initializeAwesomplete = ($nameInput, guestNames) => {
  new Awesomplete($nameInput[0], {
    list: guestNames,
    filter: Awesomplete.FILTER_CONTAINS,
    minChars: 3,
    // maxItems: 20
  });

  const debouncedValidateInput = debounce(
    () => validateNameFromList($nameInput, guestNames),
    300
  );
  $nameInput.on("input", debouncedValidateInput);

  $nameInput.on("awesomplete-selectcomplete", () =>
    validateNameFromList($nameInput, guestNames)
  );

  $("#guestForm").on("submit", (event) => {
    event.preventDefault();
    if (validateFormSubmission(event, $nameInput, guestNames)) {
      updateGuests();
    } else {
      console.log('somethings wrong habibi');
    }
  });

  $("#reponseGuestConfirmationModal").on("hidden.bs.modal", function (e) {
    $("#error-message").hide();
    $("#form-content").hide();
    $("#name").val("");
    $("#submitAttendancyBtn").prop("disabled", true);
  });

};

export async function initGuestConfirmationForm() {
  if (process.env.IS_GUEST_FORM_ENABLED === "true") {
    const guestsList = await guests.getGuests() || [];
    const guestNames = guestsList.map((guest) => guest.name) || [];
    $('#emamine-guest-confirmation').load('../../components/guest-confirmation-form.html', function () {
      const $nameInput = $("#name");
      initializeAwesomplete($nameInput, guestNames);
    });
  }

  console.log("fin : initGuestConfirmationForm");
}

async function updateGuests() {
  const guestsToUpdate = [];

  $("[id^=guestName]").each(function (index, element) {
    const $guestNameElt = $(element);
    const guestID = $guestNameElt.data("guest-id");
    const guestName = $guestNameElt.text();
    const guestEmail = $("#email-" + guestID).val();
    const guestConfirmation = $(`input[name="confirmationOptions-${guestID}"]:checked`).val();
    const guestVege = $(`input[name="vegeOptions-${guestID}"]:checked`).val();
    const guestNotAcool = $(`input[name="alcoholfreeOptions-${guestID}"]:checked`).val();
    const guestMenuChild = $(`input[name="menuChildOptions-${guestID}"]:checked`).val();
    const guestComments = $("#comments-" + guestID).val();

    const updatedGuest = {
      id: guestID,
      name: guestName,
      email: guestEmail,
      is_confirmed: guestConfirmation === "true",
      is_vege: guestVege === "true",
      is_notalcool: guestNotAcool === "true",
      is_menuChild: guestMenuChild === "true",
      comments: guestComments,
    };

    guestsToUpdate.push(updatedGuest);
  });

  try {
    const result = await guests.editGuestList(guestsToUpdate);

    if (result) {
      var myModal = new bootstrap.Modal(document.getElementById('reponseGuestConfirmationModal'), {
        backdrop: true,
        keyboard: true
      });

      myModal.show();
    } else {
      alert("error : ");
    }
  } catch (error) {
    console.error("Error updating guests:", error);
  }
}